import { useEffect, useEffectEvent } from "react";

/** Start a fresh draft on opening while the DLS overlay itself stays mounted. */
export function useDialogReset(open: boolean, reset: () => void) {
  const resetDraft = useEffectEvent(reset);
  useEffect(() => {
    if (open) resetDraft();
  }, [open]);
}
